import { useAppConfig } from '@/shared/features/app-config/context/app-config-context';
import { TGroupsConfig } from '@/shared/features/groups/context/groups-config-context.types';

export const useGroupsConfig = (): TGroupsConfig => useAppConfig().groups;
